import { React, useState, useEffect, useCallback } from "react";
import Header from "../Header";
import pdf from "../assets/pdf.png";
import { BiTrash } from "react-icons/bi";
import { Helmet } from "react-helmet-async";
import { /* BiSolidCheckCircle, */ BiCalendarAlt, BiMap } from "react-icons/bi";
// import car from '../assets/Car-Icon.png';
import customerSupportImage from "../assets/customer-subport.png";
import carGiftImg from "../assets/car-gift.png";
import faceImage from "../assets/happy-smlie.png";
import faceImg from "../assets/customer-gallery.png";
import faceImg2 from "../assets/customer-gallery2.png";
import Loading from "../Loading";
import HTTP_BASE_URL from "../../constants/HttpConstants";
import { ToastContainer, toast } from "react-toastify";
import LoadingImage from "../assets/Loading.gif";
import BookingLocations from "../BookingLocations";
import TruncatedView from "../TruncatedView";
import { IoWarningOutline } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../Footer";
import { IoArrowBackSharp } from "react-icons/io5";
import AmountHistory from "../AmountHistory";

const Documents = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Extract "id" from the URL
  const customertoken = localStorage.getItem("customertoken");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [kycOptions, setKycOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [bookingLocation, setBookingLocation] = useState(false);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [quoteStatus, setQuoteStatus] = useState([]);
  const [amountHistory, setAmountHistory] = useState(false);
  const [bookingStatus, setBookingStatus] = useState([]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [faceImage, faceImg, faceImg2];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  });

  const toastrOptions = {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  const getKycDocType = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("bookingid", id);
    try {
      await fetch(HTTP_BASE_URL + "getKycDocType", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            setKycOptions(result.data);
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      // setError(error); // Store any errors in the state
      console.error("Error:", error);
    }
  }, [id, customertoken, navigate]);

  const getKycList = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("bookingid", id);
    try {
      await fetch(HTTP_BASE_URL + "getKycList", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            setFiles(result.data);
            // console.log('getKycList', result.data);
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      // setError(error); // Store any errors in the state
      console.error("Error:", error);
    }
  }, [id, customertoken, navigate]);

  const getBookDetails = useCallback(async () => {
    const myHeaders = new Headers();
    myHeaders.append("access-token", "508b1430-68f0-4b2f-9003-3c2a0eb2a54a");
    myHeaders.append("customertoken", customertoken);
    const formdata = new FormData();
    formdata.append("id", id);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    try {
      await fetch(HTTP_BASE_URL + "getBookingdetails", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            setBookingDetails(result.data);
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      // setError(error); // Store any errors in the state
      console.error("Error:", error);
    }
  }, [id, customertoken, navigate]);

  const getBalance = useCallback(async () => {
    const formData = new FormData();
    formData.append("id", id);
    try {
      await fetch(HTTP_BASE_URL + "getBalance", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            setQuoteStatus(result.data);
            // console.log(result.data);
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      console.error(error);
    }
  }, [id, customertoken, navigate]);

  const getEnquiryDetails = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("id", id);
    try {
      await fetch(HTTP_BASE_URL + "getEnquiryDetails", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            setBookingStatus(result.data);
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      // setError(error); // Store any errors in the state
      console.error("Error:", error);
    }
  }, [id, customertoken, navigate]);

  // quote and invoice amount show

  const invoice = Number(quoteStatus?.invoice) || 0;
  const invoiceExists = invoice > 0; // If invoice exists, show invoiced amount
  const balance = quoteStatus?.balance ?? 0;
  const paid = quoteStatus?.paid ?? 0;

  // Set the displayed amount and text
  const amountLabel = invoiceExists ? "Invoiced Amount" : "Quoted Amount";
  const amountValue = invoiceExists ? quoteStatus?.invoice : quoteStatus?.quote;

  // Determine if the payment button should be disabled
  const isPayDisabled = balance <= 0;

  const tokenExpiry = useCallback(() => {
    if (!customertoken) {
      // Step 1: Clear storage
      localStorage.clear(); // or sessionStorage.clear();
      // Step 2: Redirect to login or home page
      navigate("/", { replace: true });
      // Step 3: Prevent going back to the previous page
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = () => {
        window.history.pushState(null, "", window.location.href);
      };
    }
  }, [customertoken, navigate]);

  useEffect(() => {
    getKycDocType();
    getKycList();
    getBookDetails();
    getBalance();
    getEnquiryDetails();
    tokenExpiry();
    setTimeout(() => {
      setIsLoading(false);
    }, 1200);
  }, [
    getKycDocType,
    getKycList,
    getBookDetails,
    getBalance,
    getEnquiryDetails,
    tokenExpiry,
  ]);

  // const fileSizes = (bytes, decimals = 2) => {
  //     if (bytes === 0) return '0 Bytes';
  //     const k = 1024;
  //     const dm = decimals < 0 ? 0 : decimals;
  //     const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  //     const i = Math.floor(Math.log(bytes) / Math.log(k));
  //     return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  // };

  // const generateId = () => Date.now() + Math.random().toString(36).substr(2, 9);

  // const inputChange = (e) => {

  //     document.getElementById('error').innerHTML = '';
  //     const filesArray = Array.from(e.target.files);
  //     filesArray.forEach(file => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //             setSelectedFiles(prevFiles => [
  //                 ...prevFiles,
  //                 {
  //                     id: generateId(),
  //                     filename: file.name,
  //                     filetype: file.type,
  //                     fileimage: reader.result,
  //                     datetime: file.lastModifiedDate.toLocaleString('en-IN'),
  //                     filesize: fileSizes(file.size),
  //                 }
  //             ]);
  //         };
  //         reader.readAsDataURL(file);
  //     });
  // };

  // const inputChange = (e) => {
  //     const files = Array.from(e.target.files);

  //     const readFiles = files.map((file) => {
  //         return new Promise((resolve, reject) => {
  //             const reader = new FileReader();
  //             reader.onload = () => {
  //                 resolve({
  //                     id: Math.random().toString(36).substr(2, 9), // Unique ID for each file
  //                     filename: file.name,
  //                     fileimage: reader.result, // Base64 string
  //                     filesize: (file.size / 1024).toFixed(2) + ' KB',
  //                     datetime: new Date().toLocaleString(),
  //                 });
  //             };
  //             reader.onerror = reject;
  //             reader.readAsDataURL(file);
  //         });
  //     });

  //     Promise.all(readFiles)
  //         .then((filesData) => setSelectedFiles([...selectedFiles, ...filesData]))
  //         .catch((err) => console.error('Error reading files:', err));
  // };

  const inputChange = (e) => {
    document.getElementById("error").innerHTML = "";
    const file = e.target.files[0]; // Get the first file

    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setSelectedFiles([
        {
          id: Math.random().toString(36).substr(2, 9), // Unique ID
          filename: file.name,
          fileimage: reader.result, // Base64 string
          filesize: (file.size / 1024).toFixed(2) + " KB",
          datetime: new Date().toLocaleString(),
        },
      ]);
    };
    reader.onerror = (err) => console.error("Error reading file:", err);
    reader.readAsDataURL(file);
  };

  const deleteSelectedFile = (id) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      setSelectedFiles((prevFiles) =>
        prevFiles.filter((files) => files.id !== id)
      );
    }
  };

  const fileUploadSubmit = async (e) => {
    e.preventDefault();
    // e.target.reset();
    // setFiles(prevFiles => [...prevFiles, ...selectedFiles]);
    // setSelectedFiles([]);

    // let updatedValues = { ...inputValues };
    if (selectedFiles.length > 0) {
      setIsSubmitting(true);
      const formData = new FormData(e.target);

      formData.append("bookingid", id);
      formData.append("kyc_status", "1");
      const file = selectedFiles[0];
      formData.append("file", file.fileimage);

      // selectedFiles.forEach((file, index) => {
      //     // formData.append(`file${index}`, file.fileimage); // Send as Base64 string
      // });

      // for (const [key, value] of formData.entries()) {
      //     // console.log(key, value);
      // }

      try {
        // Simulate delay for spinner demo
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Submit the form data via API
        const response = await fetch(HTTP_BASE_URL + "saveKyc", {
          method: "post",
          headers: {
            "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
            customertoken: customertoken,
          },
          body: formData,
        });
        const result = await response.json();
        // Handle API response
        if (result.code === 0) {
          // console.log("Form submitted successfully:", result);
          setIsSubmitted(false);
          setSelectedFiles([]);
          e.target.reset();
          toast.success("File uploaded successfully.", { toastrOptions });
          setTimeout(function () {
            // handleReload()
            window.location.reload();
          }, 1500);
        } else if (result.code === 1) {
          toast.error("Please upload a valid file.", {
            toastrOptions,
          });
        } else {
          console.error("API error:", result);
          // alert("Failed to submit the form. Please try again.");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        // alert("An error occurred. Please try again.");
      } finally {
        setIsSubmitting(false); // Hide loading spinner
      }
    } else {
      document.getElementById("error").innerText = "Please select a file.";
    }
  };

  const deleteFile = async (id, booking_id) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      // setFiles(prevFiles => prevFiles.filter(file => file.id !== id));
      // console.log('id', id, 'bookingid', booking_id)
      const formData = new FormData();
      formData.append("id", id);
      formData.append("bookingid", booking_id);
      try {
        await fetch(HTTP_BASE_URL + "deleteKyc", {
          method: "post",
          headers: {
            "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
            customertoken: customertoken,
          },
          body: formData,
        })
          .then((response) => response.json())
          .then((result) => {
            // console.log(result.data)
            if (result.code === 0) {
              toast.success("File deleted successfully.", { toastrOptions });
              setTimeout(function () {
                // handleReload()
                window.location.reload();
              }, 1500);
            }
          });
      } catch (error) {
        console.error(error);
      }
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Helmet>
        <title>#{id}</title>
      </Helmet>
      <Header />
      {bookingLocation && (
        <BookingLocations close={setBookingLocation} id={id} />
      )}
      {amountHistory && <AmountHistory close={setAmountHistory} id={id} />}

      <div className="container-fluid booking-section">
        <div className="container">
          <div className="row booking-row pt-lg-4 pb-lg-5">
            <div className="col d-md-none col-lg-1 "></div>
            <div className="col col-md-7 col-lg-6 col-12 p-0 ">
              <div className="bookingDiv">
                <div className="booking-inline-row justify-content-space-between">
                  <div className="pb-2">
                    <p className="sub-heading f-20 fw-semibold sm-f-15 red">
                      KYC Documents
                    </p>
                  </div>
                  <span
                    className="text-span link-btn"
                    onClick={() => {
                      navigate(`/booking/${id}`);
                    }}
                  >
                    <IoArrowBackSharp />
                    Back
                  </span>
                </div>
                <div className="booking-inline-row d-block border-none">
                  <div>
                    <span className="sub-heading pb-1">Documents Required</span>
                    <ol className="text-para list">
                      <li>Vehicle's RC book</li>
                      <li>Aadhar Card of the owner</li>
                      <li>PAN Card of the owner</li>
                      <li>
                        Vehicle's insurance, with a minimum validity of 15 days
                        from the renewal date
                      </li>
                      <li>Tax papers</li>
                    </ol>

                    <form onSubmit={fileUploadSubmit}>
                      <div className="upload-details">
                        <div className="form-control">
                          <label htmlFor="documentFile">
                            Document Type <span className="req-span">*</span>
                          </label>
                          <select id="documentFile" name="doc_type" required>
                            {/* <option value="">--Select--</option> */}
                            {kycOptions.map((option) => (
                              <option key={option.id} value={option.kyc_type}>
                                {option.display}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="file-upload-box">
                          <input
                            type="file"
                            id="fileupload"
                            accept="image/*,application/pdf"
                            className="file-upload-btn"
                            onChange={inputChange}
                          />
                          <span htmlFor="fileupload" className="file-link">
                            Choose File
                          </span>
                        </div>
                      </div>
                      <div className="kb-attach-box mt-4">
                        {selectedFiles.map(
                          ({ id, filename, fileimage, datetime, filesize }) => (
                            <div className="file-atc-box" key={id}>
                              <div className="file-actions">
                                <BiTrash
                                  onClick={() => deleteSelectedFile(id)}
                                />
                              </div>
                              <div className="file-image">
                                {filename.match(/.(jpg|jpeg|png|gif|svg|webp)$/i) ? (
                                  <img src={fileimage} alt="User uploaded document" />
                                ) : (
                                  <img
                                    src={pdf}
                                    alt="PDF document preview"
                                    width={62}
                                    height={62}
                                    loading="eager"
                                  />
                                )}
                              </div>
                              {/* <div className="file-detail">
                                                            <h6>{filename}</h6>
                                                            <p>
                                                                <span>Size: {filesize}</span>
                                                                <span className="ml-2">Modified Time: {datetime}</span>
                                                            </p>
                                                        </div> */}
                            </div>
                          )
                        )}
                      </div>
                      <p id="error" className="text-para red"></p>
                      <div className="kb-buttons-box pt-4">
                        {/* <button type="submit" className="upload-btn kyc-up-btn">Upload</button> */}
                        <button
                          type="submit"
                          className="upload-btn kyc-up-btn"
                          disabled={isSubmitting || isSubmitted}
                        >
                          {isSubmitting
                            ? "uploading..."
                            : isSubmitted
                            ? "Uploaded"
                            : "Upload"}
                          <span className="sub-loading">
                            {isSubmitting && (
                              <img
                                src={LoadingImage}
                                alt="Progress indicator"
                                width={25}
                                height={25}
                                loading="eager"
                              />
                            )}
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="bookingDiv mt-4">
                <div className="booking-inline-row d-block">
                  <p className="sub-heading f-20 fw-semibold sm-f-15">
                    All Documents
                  </p>
                </div>
                {/* {files.length > 0 && (
                                                <div>
                                                    {files.map(({ id, filename, fileimage, datetime, filesize }) => (
                                                        <div className="booking-inline-row" key={id}>
                                                            <div className="full-file-detail">
                                                                <div className="full-file-image">
                                                                    {filename.match(/.(jpg|jpeg|png|gif|svg)$/i) ? (
                                                                        <img src={fileimage} alt="" />
                                                                    ) : (
                                                                        <img src={pdf} alt="" width={62} height={62} loading="eager" />
                                                                    )}
                                                                </div>
                                                                <p className='sub-heading'>{filename}</p>
                                                                <span className="text-para">{datetime}</span>
                                                                <a href={fileimage} className="text-para download-btn" download={filename}>Download</a>
                                                                <div className="file-actions">
                                                                    <BiTrash onClick={() => deleteFile(id)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )} */}
                {files.length > 0 && (
                  <div>
                    {files
                      .slice() // Create a shallow copy to avoid mutating the original array
                      .reverse() // Reverse the array to show the latest item first
                      .map((files) => (
                        <div
                          className="booking-inline-row"
                          key={files.kyc_doc_id}
                        >
                          <div className="full-file-detail">
                            <div className="full-file-image">
                              {files.kyc_doc_path.match( /.(jpg|jpeg|png|gif|svg|webp)$/i)
                               ? (
                                <img
                                  src={files.kyc_doc_path}
                                  alt="User uploaded document"
                                  width={62}
                                  height={62}
                                  loading="eager"
                                />
                              ) : (
                                <img
                                  src={pdf}
                                  alt="PDF document preview"
                                  width={62}
                                  height={62}
                                  loading="eager"
                                />
                              )}
                            </div>
                            <p className="sub-heading" value={files.kyc_doc_id}>
                              {files.kyc_doc_id_name}
                            </p>
                            <span className="text-para">
                              {files.added_date}
                            </span>
                            {files && (
                              <span className="text-para">
                                {files.kyc_status_name === "Unknown" && (
                                  <span className="status Unknown">
                                    {files.kyc_status_name}
                                  </span>
                                )}
                                {files.kyc_status_name === "Not Verified" && (
                                  <span className="status not-verified">
                                    {files.kyc_status_name}
                                  </span>
                                )}
                                {files.kyc_status_name === "Rejected" && (
                                  <span className="status rejected">
                                    {files.kyc_status_name}
                                  </span>
                                )}
                                {files.kyc_status_name === "Pending" && (
                                  <span className="status pending">
                                    {files.kyc_status_name}
                                  </span>
                                )}
                                {files.kyc_status_name === "Verified" && (
                                  <span className="status verified">
                                    {files.kyc_status_name}
                                  </span>
                                )}
                              </span>
                            )}

                            {/* <a href={files.kyc_doc_path} className="text-para download-btn" download={files.kyc_doc_id_name}>Download</a> */}
                            <div className="file-actions">
                              {files.kyc_status_name === "Not Verified" ||
                              files.kyc_status_name === "Pending" ||
                              files.kyc_status_name === "Rejected" ? (
                                <BiTrash
                                  onClick={() =>
                                    deleteFile(
                                      files.kyc_doc_id,
                                      files.booking_id
                                    )
                                  }
                                />
                              ) : (
                                <BiTrash className="disabled" />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
            {/* ---right col----- */}
            <div className="col col-md-4 col-lg-4 p-0">
              <div className="bookingDiv border-left-right">
                <div className="box">
                  <p className="sub-heading">
                    Booking Details
                    <span className="text-para black">
                      {" "}
                      #{bookingDetails?.bookingid || "NA"}{" "}
                    </span>
                       </p>
                </div>
                <div className="box-flex">
                  <div className="div">
                    <p className="sub-heading f-15 text-center d-inline-block">
                      <span className="text-span black Moulpali">
                        {bookingDetails ? (
                          bookingDetails?.carno === "null" ||
                          !bookingDetails?.carno ? (
                            <>
                              <span className="carno-firstline">**</span>
                              <br />
                              ****
                            </>
                          ) : (
                            <>
                              <span className="carno-firstline">
                                {bookingDetails.carno
                                  .replace(/\s/g, "")
                                  .slice(0, 4)}
                              </span>
                              <br />
                              {bookingDetails.carno.replace(/\s/g, "").slice(4)}
                            </>
                          )
                        ) : (
                          ""
                        )}
                      </span>
                    </p>
                  </div>

                  <button
                    className="text-span link-btn"
                    onClick={() => setBookingLocation(true)}
                  >
                    {bookingDetails
                      ? bookingDetails?.pickuplocation_latlon === "null" ||
                        !bookingDetails?.pickuplocation_latlon ||
                        !bookingDetails?.deliverylocation_latlon ||
                        bookingDetails?.deliverylocation_latlon === "null"
                        ? "Add"
                        : "Edit"
                      : ""}
                  </button>
                </div>
                <div className="box-flex dots">
                  <p className="text-para black">
                    <BiMap className="red" />
                    <TruncatedView
                      text={bookingStatus?.pickuplocation}
                      maxLength={20}
                      placeholder="NA"
                    />
                  </p>

                  <button
                    className={`text-para ${
                      bookingDetails?.pickuplocation_latlon &&
                      bookingDetails.pickuplocation_latlon !== "null"
                        ? "fw-semibold black"
                        : ""
                    }`}
                    onClick={() => {
                      if (
                        bookingDetails?.pickuplocation_latlon &&
                        bookingDetails.pickuplocation_latlon !== "null"
                      ) {
                        const [lat, lng] =
                          bookingDetails.pickuplocation_latlon.split(",");
                        const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
                        window.open(googleMapsUrl, "_blank"); // Open the URL in a new tab
                      } else {
                        console.error(
                          "Pickup location is not available or invalid."
                        );
                      }
                    }}
                  >
                    {bookingDetails &&
                    (bookingDetails.pickuplocation_latlon === "null" ||
                      !bookingDetails.pickuplocation_latlon) ? (
                      <IoWarningOutline className="red danger" />
                    ) : (
                      ""
                    )}
                    Pickup Map Location
                  </button>
                </div>
                <div className="box-flex">
                  <p className="text-para black">
                    <BiMap />
                    <TruncatedView
                      text={bookingStatus?.deliverylocation}
                      maxLength={20}
                      placeholder="NA"
                    />
                  </p>
                  <button
                    className={`text-para ${
                      bookingDetails?.deliverylocation_latlon &&
                      bookingDetails.deliverylocation_latlon !== "null"
                        ? "fw-semibold black"
                        : ""
                    }`}
                    onClick={() => {
                      if (
                        bookingDetails?.deliverylocation_latlon &&
                        bookingDetails.deliverylocation_latlon !== "null"
                      ) {
                        const [lat, lng] =
                          bookingDetails.deliverylocation_latlon.split(",");
                        const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
                        window.open(googleMapsUrl, "_blank"); // Open the URL in a new tab
                      } else {
                        console.error(
                          "Delivery location is not available or invalid."
                        );
                      }
                    }}
                  >
                    {bookingDetails &&
                    (bookingDetails.deliverylocation_latlon === "null" ||
                      !bookingDetails.deliverylocation_latlon) ? (
                      <IoWarningOutline className="red danger" />
                    ) : (
                      ""
                    )}
                    Delivery Map Location
                  </button>
                </div>
                {bookingDetails?.pickuptime ? (
                  <div className="box-flex">
                    <span className="sub-heading">
                      <p className="text-para">Pickup Date & Time</p>
                      <BiCalendarAlt
                        style={{
                          width: "16px",
                          height: "16px",
                          color: "#D7000C",
                          marginRight: "7px",
                        }}
                      />
                      {bookingDetails
                        ? bookingDetails?.pickuptime === "null" ||
                          !bookingDetails?.pickuptime
                          ? "NA"
                          : bookingDetails?.pickuptime
                        : ""}
                    </span>
                  </div>
                ) : (
                  <div className="box-flex">
                    <span className="sub-heading">
                      <p className="text-para">Pickup Date & Time</p>
                      <BiCalendarAlt
                        style={{
                          width: "16px",
                          height: "16px",
                          color: "#D7000C",
                          marginRight: "7px",
                        }}
                      />
                      -/-
                    </span>
                  </div>
                )}
              </div>
              <div className="bookingDiv total-amout">
                <div className="box-flex p-0">
                  <p className="text-para">{amountLabel}</p>
                  <p className="sub-heading">
                    {amountValue > 0 ? <> &#x20b9; {amountValue}</> : "-"}{" "}
                    <br />
                  </p>
                </div>
                <div className="box-flex p-0">
                  <p className="text-para">Paid</p>
                  <p className="sub-heading">
                    {paid > 0 ? <> &#x20b9; {paid} </> : "-"} <br />
                  </p>
                </div>
                <div className="box-flex p-0">
                  <p className="sub-heading">Balance</p>
                  {balance > 0 ? (
                    <p className="sub-heading f-20 amount">
                      <> &#x20b9; {balance} </> <br />
                    </p>
                  ) : (
                    <>
                      {isPayDisabled && invoiceExists && (
                        <p className="text-span span">No due</p>
                      )}
                    </>
                  )}
                </div>

                {invoiceExists && balance > 0 && (
                  <p className="text-span span">Inclusive of all taxes</p>
                )}
                {quoteStatus?.quote === 0 && (
                  <p className="text-span span">Quote not prepared</p>
                )}
                {!invoiceExists && quoteStatus?.quote !== 0 && (
                  <p className="text-span span text-start">
                    The final amount may be subject to change after the invoice
                    is created.
                  </p>
                )}
              </div>
              <div
                className={`pay-now pay-now-btn ${
                  isPayDisabled ? "disabled-bg" : ""
                }`}
                onClick={() => {
                  if (!isPayDisabled) {
                    const bookingId = bookingDetails?.bookingid || "";
                    if (bookingId) {
                      navigate(`/payment/${bookingId}`);
                    }
                  }
                }}
              >
                {isPayDisabled && invoiceExists ? "No due" : "Pay Now"}
              </div>
              <div className="bookingDiv border-radius">
                <div className="box-flex p-0 justify-content-center">
                  <p
                    className="text-span link-btn"
                    onClick={() => setAmountHistory(true)}
                  >
                    Payment History
                  </p>
                </div>
              </div>
              <div className="bookingDiv mt-4">
                <div className="box-flex p-0">
                  <div className="col">
                    <img
                      src={customerSupportImage}
                      className="customer-support-img"
                      alt="customer-subport"
                      width={84}
                      height={84}
                      loading="eager"
                    />
                  </div>
                  <div className="col col-8">
                    <p className="sub-heading f-20 fw-semibold">
                      Looking for help?
                    </p>
                    <p className="text-para">
                      We are available all working days. <br /> You can call us
                      at
                    </p>
                    <p className="sub-heading"> 044-26211718 / 26211819</p>
                    <p className="sub-heading">044-26208376 / 26208377</p>
                  </div>
                </div>
              </div>
              <div className="bookingDiv mt-4">
                <div className="box-flex p-0 d-block text-center">
                  <img
                    src={carGiftImg}
                    alt="cargift"
                    width={108}
                    height={108}
                    loading="eager"
                  />
                  <p className="sub-heading mb-1 f-20 fw-semibold">
                    Happy Faces <br /> from our customers
                  </p>
                  <p className="text-para pb-2 d-xxl-none">
                    Happy customers, happy us! <br /> Read their testimonials
                    and join <br /> the ranks of satisfied smiles
                  </p>
                  <p className="text-para d-none d-xxl-block">
                    Happy customers, happy us! Read their testimonials and join
                    the ranks of satisfied smiles
                  </p>
                  <div className="slider-container pb-1">
                    {images.map((image, index) => {
                      let positionClass = "image-left"; // Default left position

                      if (index === (currentIndex + 1) % images.length) {
                        positionClass = "image-right"; // Right-side image
                      }
                      if (index === currentIndex) {
                        positionClass = "image-center"; // Center large image
                      }

                      return (
                        <img
                          key={index}
                          src={image}
                          alt={`Symbolizes delivery inspection and service excellence ${
                            index + 1
                          }`}
                          className={`slider-image ${positionClass}`}
                        />
                      );
                    })}
                  </div>
                  {/* <p><button to="#" className='upload-btn bg-blue'>Add your review</button></p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Documents;
